import { Component, h, Prop, State } from '@stencil/core';
import get from 'lodash/get';
import { getVideos, getNews } from '../../shared/api'
import { SectionLatestVideos, SectionProductDetails } from '../../functional'
import Store from '../../store/store'

@Component({
    tag: 'app-dynamic-section'
})
export class AppDynamicSection {

    @Prop() __component: string;
    @Prop() data: any = {};
    @Prop() page?: number = 1;
    @State() dynamicData: any = {};


    async getVideos(){
        const dynamicData = this.data;
        const Limit = ['s'].includes(Store.browser['mediaSize']) ? 3 : (get(dynamicData, 'Limit') || get(Store, 'website.VideosMaxResults'));
        const filters = (get(dynamicData, 'ApplyFilters.data') || []).map(({ id }) => id);
        const product = get(dynamicData, 'Product.data.id');
        const { data, status } = await getVideos(1, filters, Limit, product)
        if (status !== 200) return;
        dynamicData.Items = data?.data.map(({ attributes }) => attributes);
        this.dynamicData = dynamicData;
    }

    async getNews() {
        const dynamicData = this.data;
        const { Product } = dynamicData
        const NewsLimit = get(dynamicData, 'NewsLimit') || get(Store, 'website.NewsMaxResults');
        const filters = (get(dynamicData, 'ApplyFilters.data') || []).map(({ id }) => id);
        const { data, status } = await getNews(1, filters, NewsLimit, Product)
        if (status !== 200) return;
        dynamicData.News = data;
        this.dynamicData = dynamicData;
    }

    async componentWillRender() {
        switch (this.__component){
            case 'sections.latest-videos': return await this.getVideos()
            case 'sections.product-details': return await this.getNews()
        }
    }

    render() {
        switch (this.__component) {
            case 'sections.latest-videos': return <SectionLatestVideos data={this.dynamicData} />
            case 'sections.product-details': return <SectionProductDetails data={this.dynamicData} />
        }
    }
}
